export const CategorySplitStorageKey = 'category-split';
